import React, { useState } from 'react';
import useProxyAuth from '../hooks/useProxyAuth';
import UPPage from '../components/UPPage';
import AgreementsApprove from '../components/AgreementsApprove';
import { LinearProgress, Link } from '@mui/material';
import { ErrorCodes, ResponseErrorBodyDataNotSignedAgreement } from '../types';
import { useTranslation } from 'react-i18next';

const LoginFormLazy = React.lazy(() => import('./../components/LoginForm'));

/**
 * Main Page
 */
export default function() {
  const [resend, setResend] = useState(0);
  const { isLogged, response } = useProxyAuth(resend);

  const { t } = useTranslation();

  if (isLogged || isLogged === undefined) {
    return <LinearProgress color="primary" />;
  }

  let content;
  if (
    response &&
    response.error &&
    response.error.code === ErrorCodes.NOT_SIGNED_AGREEMENT
  ) {
    content = (
      <AgreementsApprove
        agreementsUnsigned={
          (response.error.data as ResponseErrorBodyDataNotSignedAgreement)
            .agreements
        }
        onSuccess={() => setResend(resend => resend + 1)}
      />
    );
  } else {
    content = (
      <>
        <LoginFormLazy typeLogin="" />
        <Link
          href={'/auth/forgotPassword'}
          sx={{ cursor: 'pointer' }}
          alignSelf={'flex-start'}
        >
          {t('forgotPassword')}
        </Link>
      </>
    );
  }

  return <UPPage>{content}</UPPage>;
}
